import { API } from "../../constants/api";
import useAuthAxios from "../../utils/baseAxios";
import { useQuery } from "@tanstack/react-query";

const useAllRates = () => {
  const axiosInstance = useAuthAxios();

  const getRate = async () => {
    const response = await axiosInstance.get(API.getRates);
    return response.data.data.rates;
  };

  const { data: rates } = useQuery({
    queryKey: ["get-rates"],
    queryFn: getRate,
    retry: 1,
  });

  return rates;
};

export default useAllRates;
